module.exports = __webpack_public_path__ + "img/southeast-spring-1920x550.b5a34fe6.jpg";